
// import Slider from "react-slick";

// import "./OfferSlider.css";

// const settings = {
//   dots: false,
//   arrows: true,
//   infinite: true,
//   speed: 700,
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   pauseOnHover: true,
//   swipe: true,
//   draggable: true,
//   lazyLoad: "ondemand",
//   responsive: [
//     {
//       breakpoint: 1200, // lg
//       settings: { slidesToShow: 2 },
//     },
//     {
//       breakpoint: 992, // md
//       settings: { slidesToShow: 2 },
//     },
//     {
//       breakpoint: 768, // sm
//       settings: { slidesToShow: 1, arrows: false },
//     },
//     {
//       breakpoint: 576, // xs
//       settings: { slidesToShow: 1, arrows: false },
//     },
//   ],
// };


// const OfferSlider = ({ bundlesRef, banner50Images = [] }) => {
//   console.log(banner50Images);

//   return (
//     <div className="offer-slider-wrap" ref={bundlesRef} id="bundles">
//       <Slider {...settings}>
//         {banner50Images.map((img, index) => (
//           <div key={index} className="slide">
//             <div className="ratio-box">
//               <img
//                 className="banner-img"
//                 src={img.imageUrl}
//                 alt={`Offer ${index + 1}`}
//                 loading="lazy"
//               />
//             </div>
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default OfferSlider;




import { useState } from "react";
import Slider from "react-slick";
import "./OfferSlider.css";

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 700,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  swipe: true,
  draggable: true,
  lazyLoad: "ondemand",
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 2 } },
    { breakpoint: 992, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1, arrows: false } },
    { breakpoint: 576, settings: { slidesToShow: 1, arrows: false } },
  ],
};

const OfferSlider = ({ bundlesRef, banner50Images = [] }) => {
  // track loading for each image
  const [loaded, setLoaded] = useState({});

  const handleImageLoad = (index) => {
    setLoaded((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <div className="offer-slider-wrap" ref={bundlesRef} id="bundles">
      <Slider {...settings}>
        {banner50Images.map((img, index) => (
          <div key={index} className="slide">
            <div className="ratio-box">
              {!loaded[index] && (
                <div className="img-loader">
                  <div className="spinner"></div>
                </div>
              )}
              <img
                className={`banner-img ${loaded[index] ? "visible" : "hidden"}`}
                src={img.imageUrl}
                alt={`Offer ${index + 1}`}
                onLoad={() => handleImageLoad(index)}
                onError={() => handleImageLoad(index)}
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default OfferSlider;

